var $ = require('../../modules/$');
module.exports = function defineProperty(it, key, desc){
  return $.setDesc(it, key, desc);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-polyfill/~/babel-runtime/~/core-js/library/fn/object/define-property.js
 ** module id = 3
 ** module chunks = 0 1
 **/